var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.company
    ? _c(
        "section",
        { staticClass: "w-full" },
        [
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.$apollo.loading,
                spinnerCentered: "",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex justify-between mb-4 items-center" },
                [
                  _c(
                    "h1",
                    {
                      staticClass:
                        "font-semibold w-max-content custom-title mt-1 mb-2",
                    },
                    [_vm._v("Job Postings")]
                  ),
                  _c("UiButton", {
                    attrs: {
                      buttonText: "Create Posting",
                      variant: "black",
                      size: "lg",
                    },
                    on: { click: _vm.toggle },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icon",
                          fn: function () {
                            return [_c("PlusIcon", { staticClass: "w-4 h-4" })]
                          },
                          proxy: true,
                        },
                        {
                          key: "hover-icon",
                          fn: function () {
                            return [
                              _c("HoveredIcon", { staticClass: "w-6 h-6" }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3681370335
                    ),
                  }),
                ],
                1
              ),
              _c("PostingFilters", {
                attrs: {
                  currentUserRole: _vm.currentUser.role,
                  companyId: _vm.company.id,
                  filters: _vm.postingFilters,
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  resetFilters: _vm.resetFilters,
                },
              }),
              _c("ActionPanel", {
                staticClass: "mb-4 font-medium",
                attrs: { total: _vm.paginationConfig.total },
              }),
              _vm.empty
                ? _c(
                    "EmptyListPlaceholder",
                    {
                      attrs: { title: _vm.emptyListPlaceholder },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImagePosting")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        446318279
                      ),
                    },
                    [
                      _vm.filtersEmpty
                        ? _c(
                            "UiButton",
                            {
                              attrs: { variant: "black", size: "lg" },
                              on: { click: _vm.toggle },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "icon",
                                    fn: function () {
                                      return [
                                        _c("PlusIcon", {
                                          staticClass: "w-4 h-4",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "hover-icon",
                                    fn: function () {
                                      return [
                                        _c("HoveredIcon", {
                                          staticClass: "w-6 h-6",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3681370335
                              ),
                            },
                            [_c("div", [_vm._v("Create Posting")])]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : [
                    _c(
                      "div",
                      { staticClass: "flex flex-wrap gap-4 topScroll mb-4" },
                      _vm._l(_vm.postings, function (posting) {
                        return _c("PostingCard", {
                          key: posting.id,
                          attrs: {
                            posting: posting,
                            canEdit: _vm.canUserChangePosting(posting),
                            companyId: _vm.company.id,
                            managerId: _vm.managerId,
                            inactiveManager: _vm.isManager,
                          },
                        })
                      }),
                      1
                    ),
                    _c("CardPagination", {
                      attrs: {
                        showmeta: false,
                        config: _vm.paginationConfig,
                        containerClass:
                          "bg-transparent shadow-none border-none b-custom_pagination_class",
                      },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
          _vm.dialog
            ? _c("PostingModal", {
                attrs: { companyId: _vm.company.id, managerId: _vm.managerId },
                on: { refecthPosting: _vm.hanldeRefetch },
                model: {
                  value: _vm.dialog,
                  callback: function ($$v) {
                    _vm.dialog = $$v
                  },
                  expression: "dialog",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }